import { LogIn } from "react-feather";
import { Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../reduxToolkit/hooks";
import { logout } from "../../../reduxToolkit/reducers/layout/authSlice";
import { dynamicImage } from "../../../utils";
import { routes } from "../../../routers/routes";
import { LogOut } from "../../../constants";
import SvgIcon from "../../../coreComponents/SvgIcon";
import { Image } from "../../../coreComponents/Image";
import { useEffect,useState } from "react";
import ApiService from "../../../services/apiService";
import {profileUpdate } from "../../../reduxToolkit/reducers/layout/UpdateProfileSlice";
import { clearUserId } from "../../../reduxToolkit/reducers/users/userSlice";

const Profile = () => {
  const dispatch = useAppDispatch();
  const userId = useAppSelector((state)=> state.user.userId);
  const role = useAppSelector((state)=> state.role.role)
  const updated = useAppSelector((state)=> state.profile.isProfileUpdatetd)
  const [img, setImg] = useState<string | null>(null);
   const[userName,setUserName] = useState<any>({})
    useEffect(()=>{
      
      if (!userId) { // Check if userId is falsy (logged out)
        setUserName(null);  // Clear the userName if there's no userId
        return; // Don't make the API call if userId is not available
      }
        const  getUserName = async()=>{
             try{
                 const response = await ApiService.axiosApi(`/auth/${userId}`,{
                  method:'GET'
                 })
                 if(response.success){
                     
                    setUserName(response.data)
                 }else{
                   console.log("unable to get userName")
                 }
             }catch(error){
              console.log(error)
             }
        } 
        getUserName();
       
        
    },[userId])
  useEffect(()=>{
       const getUserImg = async( )=>{
         try{
            const response = await ApiService.axiosApi(`/image`,{
                 method:'GET',

            })
            if(response.success){
               const users = response.data;
              const userImg = users.filter((user:any)=> user.identityUserId == userId)
              if (userImg.length > 0) {
                setImg(userImg[0].filePath);
              } else {
                // If no image found for the user, clear the existing image from UI
                setImg(null);
              }
            }else{
               console.log("unable to set user image")
            }
         }catch(error){
          console.log(error)
         }
       };
       getUserImg();
 
     //  dispatch(profileUpdate(false));
  },[userId,updated])
   
     
  return (
    
    <li className="profile-nav onhover-dropdown p-0 m-0">
      <div className="d-flex profile-media align-items-center" >
      {img ? (
  <img
    className="rounded-circle"
    src={img}
    alt="profile"
    style={{ width: '40px', height: '40px', objectFit: 'cover' }}
  />
) : (
  <div
    className="rounded-circle bg-secondary d-flex align-items-center justify-content-center text-white"
    style={{ width: '40px', height: '40px', fontSize: '14px' }}
  >
    N/A
  </div>
)}
        <div className="flex-grow-1">
          <span>{userName?.userName}</span>
          <p className="mb-0 d-flex align-items-center">
           {role}
            <SvgIcon iconId="header-arrow-down" />
          </p>
        </div>
      </div>
      <ul className="profile-dropdown onhover-show-div">
        {/*profileList.map((item) => (
          <li key={item.id}>
            <Link to={item.link}>
              {item.icon}
              <span>{item.text} </span>
            </Link>
          </li>
        ))*/}
        <li>
          <Link onClick={() => dispatch(logout(),clearUserId()) } to={routes.Login}>
            <LogIn />
            <span>{LogOut}</span>
          </Link>
        </li>
      </ul>
    </li>
  );
};
export default Profile;
